export const INV_ORDER = 'inv.order';

export const INV_LOCALE = 'inv.locale';

export const INV_LOCALE_REDIRECT = 'inv.locale.redirect';

/**
 * List of errors that require custom message handling.
 * Note: Adding a new error code to this array will require to add a corresponding translation key
 * in the form of 'returns.step_3.submit_errors.[error_code]'. Otherwise, it defaults to the generic error message.
 */
export const ERRORS_WITH_CUSTOM_MESSAGES = ['unknown.label.serviceability.no.service.between.locations'];
